// This is a placeholder until we get a better solution
var Localization = {

	TRANSLATIONS: {
		credit_card: {
			number: "Card number",
			security_code: "Security code",
			cvc_tooltip: "The 3 or 4 digit security code located on the back of your card.",
			expiration: "Expiration date",
			zip_code: "Zip code"
		}
	},

	getTranslations: function(key) {
		return Localization.TRANSLATIONS[key];
	}
}

module.exports = Localization;



// WEBPACK FOOTER //
// ./modules/lib/interface/Localization.js